import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const UserLoginHistoryActions = {

  fetchUserLoginHistory: async _ => {
    return axiosRequest.
      get('/users/login_history').
      then(({ data }) => data.login_history).
      catch(handleError)
  },

}
